import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';

// Generate API client
const client = generateClient({
    authMode: 'apiKey'
  });
  
// GraphQL subscription for onBroadcast
const SUBSCRIPTION = `
  subscription OnBroadcast {
    onBroadcast {
      id
      content
      timestamp
    }
  }
`;

const BroadcastSubscription = () => {
  const [messages, setMessages] = useState([]);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    // Subscribe to broadcast messages
    const sub = client.graphql({
      query: SUBSCRIPTION
    }).subscribe({
      next: ({ data }) => {
        const message = data.onBroadcast;
        setMessages(prev => [...prev, message]);
      },
      error: error => console.warn('Subscription error:', error)
    });

    // Store subscription reference
    setSubscription(sub);

    // Cleanup subscription on component unmount
    return () => {
      if (sub) {
        sub.unsubscribe();
      }
    };
  }, []);

  return (
    <div className="p-4 max-w-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">AI Response</h2>
      <div className="space-y-2 overflow-y-auto max-h-96">
        {messages.map(message => (
            message.content
        //   <div 
        //     key={message.id} 
        //     className="p-3 bg-white rounded shadow border border-gray-200"
        //   >
        //     <p className="text-gray-800">{message.content}</p>
        //     <p className="text-xs text-gray-500 mt-1">
        //       {new Date(message.timestamp).toLocaleString()}
        //     </p>
        //   </div>
        ))}
        {messages.length === 0 && (
          <p className="text-gray-500 text-center py-4">
            No messages yet. Waiting for broadcasts...
          </p>
        )}
      </div>
    </div>
  );
};

export default BroadcastSubscription;